import flat from "lodash/flattenDeep";

export default {
  props: {
    error: {
      type: [String, Boolean, Array, Object],
      required: false,
      default: false,
    },
  },
  computed: {
    isInvalid() {
      return !!this.error;
    },
    hasError() {
      return this.errors.length > 0;
    },
    stateClass() {
      return { ["is-invalid"]: this.isInvalid };
    },
    computedState() {
      return this.hasError ? false : null;
    },
    errors() {
      let data = [this.error];
      if (!this.error || typeof this.error === "boolean") {
        data = [];
      } else if (typeof this.error === "object") {
        data = Object.values(this.error);
      }

      return flat(data);
    },
  },
};
